import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  margin-top: 1.25rem;
`;

export const Brand = styled.div`
  font-weight: bold;
  font-family: "Lato";
  font-style: normal;
  font-weight: 900;
  font-size: 24px;
  line-height: 29px;
  color: #000000;
  cursor: pointer;
`;

export const HeaderRightRender = styled.div`
  display: flex;
  justify-items: center;
  align-items: center;
`;

export const GitHubLink = styled.img`
  height: 36px;
  width: 36px;
  margin-right: 10px;
  cursor: pointer;
`;
